<template>
  <div>
    <div class="d-flex" v-if="!ocultar_filtro_grupos">
      <div class="pb-3" :class="{'w-50-porcento pr-2': !ocultar_filtro_filiais, 'w-full': ocultar_filtro_filiais}">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Grupos de compra</div>

        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          outlined
          multiple
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          :config_compras_exibir_grupo_compras_usuario_ativo="compras_exibir_grupo_compras_usuario_ativo"
          @focus="focus_inputs.grupo = true"
          @blur="focus_inputs.grupo = false"
        >
          <template #prepend-inner v-if="filtros.grupos.length === 0 && !focus_inputs.grupo">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysGrupoAutocomplete>
      </div>

      <div class="pb-3 pl-1 w-50-porcento" v-if="!ocultar_filtro_filiais">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Filiais</div>

        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          :ids-grupo="filtros.grupos"
          outlined
          multiple
          :qtde-visivel-selecionados="5"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          :config_compras_exibir_grupo_compras_usuario_ativo="compras_exibir_grupo_compras_usuario_ativo"
          @focus="focus_inputs.filial = true"
          @blur="focus_inputs.filial = false"
          @processamento:finalizado="ev => $emit('processamento:finalizado', ev)"
        >
          <template #prepend-inner v-if="filtros.filiais.length === 0 && !focus_inputs.filial">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysFilialGrupoAutocomplete>
      </div>
    </div>

    <div class="d-flex">
      <div class="pb-3 pr-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Segmentos</div>

        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          exibir_apenas_segmentos_com_produtos_ativos
          @focus="focus_inputs.segmento = true"
          @blur="focus_inputs.segmento = false"
        >
          <template #prepend-inner v-if="filtros.segmentos.length === 0 && !focus_inputs.segmento">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysSegmentoAutocomplete>
      </div>

      <div class="pb-3 pl-1 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Seções</div>

        <SysSecaoAutocomplete
          v-model="filtros.secoes"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.secao = true"
          @blur="focus_inputs.secao = false"
        >
          <template #prepend-inner v-if="filtros.secoes.length === 0 && !focus_inputs.secao">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysSecaoAutocomplete>
      </div>
    </div>

    <div class="d-flex">
      <div class="pb-3 pr-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Categorias</div>

        <SysCategoriaAutocomplete
          v-model="filtros.categorias"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          :ids-secao="filtros.secoes"
          outlined
          multiple
          :qtde_visivel_selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.categoria = true"
          @blur="focus_inputs.categoria = false"
        >
          <template #prepend-inner v-if="filtros.categorias.length === 0 && !focus_inputs.categoria">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysCategoriaAutocomplete>
      </div>

      <div class="pb-3 pl-1 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Linhas</div>

        <SysLinhaAutocomplete
          v-model="filtros.linhas"
          outlined
          multiple
          :qtde_visivel_selecionados="1"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.secao = true"
          @blur="focus_inputs.secao = false"
        >
          <template #prepend-inner v-if="filtros.linhas.length === 0 && !focus_inputs.secao">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysLinhaAutocomplete>
      </div>
    </div>

    <div class="d-flex">
      <div v-if="!ocultar_filtro_compradores" class="pb-3 pr-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Compradores</div>

        <SysCompradorAutocomplete
          v-model="filtros.compradores"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          :ids-secao="filtros.secoes"
          outlined
          multiple
          :qtde_visivel_selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.comprador = true"
          @blur="focus_inputs.comprador = false"
        >
          <template #prepend-inner v-if="filtros.compradores.length === 0 && !focus_inputs.comprador">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysCompradorAutocomplete>
      </div>

      <div class="pb-3" :class="{'pl-1 w-50-porcento': !ocultar_filtro_compradores, 'w-full': ocultar_filtro_compradores}">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Fornecedores</div>

        <SysFornecedorAutocomplete
          v-model="filtros.fornecedores"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          :ids-secao="filtros.secoes"
          :ids-comprador="filtros.compradores"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.fornecedor = true"
          @blur="focus_inputs.fornecedor = false"
        >
          <template #prepend-inner v-if="filtros.fornecedores.length === 0 && !focus_inputs.fornecedor">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysFornecedorAutocomplete>
      </div>
    </div>

    <div class="d-flex">
      <div v-if="!ocultar_filtro_marcas" class="pb-3 pr-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Marcas</div>

        <SysMarcaAutocomplete
          v-model="filtros.marcas"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          :ids-secao="filtros.secoes"
          :ids-comprador="filtros.compradores"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.marca = true"
          @blur="focus_inputs.marca = false"
        >
          <template #prepend-inner v-if="filtros.marcas && filtros.marcas.length === 0 && !focus_inputs.marca">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysMarcaAutocomplete>
      </div>
    </div>
  </div>
</template>

<script>
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";
import SysLinhaAutocomplete from "@/components/utils/crud/SysLinhaAutocomplete.vue";

export default {
  name: "BlocoFiltrosPrincipais",
  components: {
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysSecaoAutocomplete,
    SysSegmentoAutocomplete,
    SysCategoriaAutocomplete,
    SysLinhaAutocomplete,
    SysMarcaAutocomplete
  },
  props: {
    filtros: Object,
    autocomplete_dense: {
      type: Boolean,
      default: false
    },
    ocultar_filtro_grupos: Boolean,
    ocultar_filtro_filiais: Boolean,
    ocultar_filtro_compradores: Boolean,
    ocultar_filtro_marcas: Boolean
  },
  emits: ["processamento:finalizado"],
  data: () => ({
    focus_inputs: {
      grupo: false,
      filial: false,
      segmento: false,
      secao: false,
      categoria: false,
      linha: false,
      comprador: false,
      fornecedor: false,
      marca: false,
    },
    compras_exibir_grupo_compras_usuario_ativo: localStorage.compras_exibir_grupo_compras_usuario === 'S',
  })
}
</script>

<style scoped>

</style>
